import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

export const OfferLetterFromTemplateModal = ({ onClose }: Props) => {
  return (
    <F0Dialog
      onClose={onClose}
      isOpen
      width="lg"
      title={i18n.t('ats.send_offer_letter_modal.from_template.title')}
    >
      --- Preview + Form HERE ---
    </F0Dialog>
  )
}
